import React, { useEffect, useState,useCallback,
    useRef,
    StrictMode, } from "react";
  import Sidebar from "../../components/Sidebar";
  import { useSelector, useDispatch } from "react-redux";
  import { Link, useNavigate } from "react-router-dom";
  import axios from "axios";
  import { apiUrl } from "../../config/Config";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
  import { Button, Modal } from "react-bootstrap";
  import "bootstrap/dist/css/bootstrap.min.css";
  import Overlay from "../../components/Overlay";
  import { useMemo } from 'react';
  import { AgGridReact } from "@ag-grid-community/react";
  import "@ag-grid-community/styles/ag-grid.css";
  import "@ag-grid-community/styles/ag-theme-quartz.css";
  import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
  import { ModuleRegistry } from "@ag-grid-community/core";
  import Select from 'react-select'

  ModuleRegistry.registerModules([ClientSideRowModelModule]);
  
  const HomepageCourses = () => {
    let navigate = useNavigate();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [cityname, setcityname] = useState("");
    const [countryname, setcountryname] = useState("");
    const [selectedid, setselectedid] = useState(0);
    const [rowData, setRowData] = useState([]);
    const [colDefs, setColDefs] = useState([]);
    const [coursesdropdown, setcoursesdropdown] = useState([]);
    const [selectedcourse, setselectedcourse] = useState([]);
    const paginationPageSizeSelector = useMemo(() => {
      return [10, 20, 50, 100];
    }, []);

    const options = [
        { value: 'India', label: 'India' },
        { value: 'United States of America', label: 'United States of America' },
        { value: 'United Kingdom', label: 'United Kingdom' },
        { value: 'Canada', label: 'Canada' },
        { value: 'Australia', label: 'Australia' },
      ];
  
    const defaultColDef = {
      flex: 1,
    };
  
    const clickhandle = () =>  {
      console.log('Mission Launched')
    }
    
    const fetchallcourses = async () => {
      setshowloding(true);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .get(apiUrl + "getallhomepagecourses", headers)
        .then((res) => {
          if (res.data.status == "success") {
            console.log('getallhomepagecourses >>', res.data);
            var prevdata = res.data.data;
            if(prevdata?.length > 0) {
              var columnsarr = [];
              var hidecolumns = ['id', 'updated_at','created_at', 'sort', 'courseid'];
              var hidefilters = [];
              var columns = Object.keys(prevdata[0]);
              for(var i = 0; i < columns?.length;i++) {
                if(!hidecolumns.includes(columns[i])) {
                  var obj = {};
                  obj.field = columns[i];
                  if(!hidefilters.includes(columns[i])) {
                    obj.filter = true;
                    obj.filterParams = {
                        filterOptions: ["contains"],
                        maxNumConditions: 1,
                    };
                  }
                //   console.log('obj >>', obj)
                  columnsarr.push(obj);
                }
              }
              //edit
              // var editobj = 
              // {
              //   field: "edit",
              //   headerName: "Edit",
              //   cellRenderer: (props) => {
                  
              //     return (
              //       <div
              //             onClick={() => {
              //               editlocation(props?.data?.id, props?.data?.city, props?.data?.country);
              //               // console.log('props >>', props?.data);
              //             }}
              //             style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
              //           >
              //             <FontAwesomeIcon
              //               icon={faPenToSquare}
              //               className="sidebaricons"
              //               style={{ color: "blue" }}
              //             />
              //           </div>
              //     )
              //   },
              //   cellRendererParams: {
              //     onClick: clickhandle,
              //   },
              // }
              // columnsarr.push(editobj);
              //delete
              var deleteobj = 
              {
                field: "delete",
                headerName: "Delete",
                cellRenderer: (props) => {
                  
                  return (
                    <div
                          onClick={() => {
                            deletecourse(props?.data?.id, props?.data?.name);
                            // console.log('props >>', props?.data);
                          }}
                          style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            className="sidebaricons"
                            style={{ color: "red" }}
                          />
                        </div>
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(deleteobj);
              setColDefs(columnsarr);
              setRowData(prevdata);
            } else {
              setColDefs([]);
              setRowData([]);
            }
            
            // setcoursesdata(res.data.data);
          } else {
            // alert(res.data.message);
          }
        })
        .catch((err) => {
          alert(err.message);
        });
        setshowloding(false);
    };

    const fetchallcoursesdropdown = async () => {
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .get(apiUrl + "getallcourses", headers)
        .then((res) => {
          if (res.data.status == "success") {
            console.log('getallcourses >>', res?.data?.data);
            var prevdata = res?.data?.data;
            var newdata = [];
            for(var i = 0; i < prevdata?.length; i++) {
              var obj = {};
              obj['value'] = prevdata[i]?.id;
              obj['label'] = prevdata[i]?.title;
              newdata.push(obj);
            }
            setcoursesdropdown(newdata);
          } else {
            // alert(res.data.message);
          }
        })
        .catch((err) => {
          alert(err.message);
        });
    }
    const deletecourse = async (id, name) => {
      const result = window.confirm("Are you sure you want to delete course from "+ name+" homepage" );
      if (result) {
        var data = JSON.stringify({
          id: id,
        });
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "deletehomepagecourse", data, headers)
          .then((res) => {
            if (res.data.status == "success") {
              fetchallcourses();
            } else {
            }
          })
          .catch((err) => {
            alert(err.message);
          });
      } else {
        // User clicked Cancel or closed the dialog
        console.log("User clicked Cancel");
      }
    };
    const submithandle = async () => {
      if (selectedcourse) {
        setshowloding(true);
        var data = {
          courseid: selectedcourse?.value,
            name: selectedcourse?.label
        };
        console.log('data >>', data);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "addnewhomecourse", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              setshowmodal(false);
              setselectedcourse("");
              fetchallcourses();
              setshowloding(false);
            } else {
              alert(res.data.message);
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
        setshowloding(false);
      } else {
        alert("Empty Field");
      }
    };
  
    const editlocation = async(id, city, country) => {
      setselectedid(id);
      setcityname(city);
      var obj = { value: country, label: country }
      setcountryname(obj);
      seteditshowmodal(true);
    }
  
    const submithandle1 = async () => {
      if (cityname && countryname) {
        setshowloding(true);
        var data = {
          id: selectedid,
          cityname: cityname,
          countryname: countryname?.value
        };
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "editcity", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
                seteditshowmodal(false);
                setselectedid(0);
                setcityname("");
                setcountryname("");
                fetchallcourses();
                setshowloding(false);
            } else {
              alert(res.data.message);
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
        setshowloding(false);
      } else {
        alert("Empty Field");
      }
    };

    const handlechange = (selectedOption) => {
        setselectedcourse(selectedOption)
    }
  
   
    useEffect(() => {
      if (userdata && Object.keys(userdata).length > 0) {
        //   fetchdata();
        fetchallcourses();
        fetchallcoursesdropdown();
      } else {
        navigate("/newadminlogin");
      }
    }, []);
    return (
      <div className="HomeMain">
          <Overlay showloader={showloding} />
        <div className="sidebar-div">
          <Sidebar name={"Admin"} />
        </div>
        <div className="main-layout">
          <div className="mainDiv">
            <p className="oneplaceHead">COURSES TO BE DISPLAYED IN HOMEPAGE (max 6)</p>
            <br />
            
              <div className="tablebuttondiv tablebuttondivpage">
              <Link
                onClick={() => {
                  if(rowData?.length > 5) {
                    alert('Max 6 courses already added to homepage. Please remove any course to add new course to homepage.')
                  } else {
                    setcityname("");
                  setcountryname("")
                  setshowmodal(true);
                  }
                  
                }}
                className="btndiv webadminmaindiv"
              >
                <p>{"Select Course"}</p>
              </Link>
            </div>
           
  
            <div
        className={
          "ag-theme-quartz"
        }
        style={{ width: "100%", height: 550 }}
      >
        <AgGridReact
        // modules={AllModules}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          suppressRowClickSelection={true}
          groupSelectsChildren={true}
          rowSelection={"multiple"}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={paginationPageSizeSelector}
          // onGridReady={onGridReady}
        />
      </div>
  
            
  
            {/*Add modal */}
            <Modal
              show={showmodal}
              onHide={() => setshowmodal(false)}
              size="md"
              className="custom-width-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title style={{fontSize: 19}}>Add Location</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="webadmin-modalmainbody">
                  <div className="mt-0">
                    <label>Course</label>
                    <Select value={selectedcourse} onChange={handlechange} options={coursesdropdown} />
                  </div>
                  <div
                    className="webadmin-modalbtn"
                    onClick={() => {
                      submithandle();
                    }}
                  >
                    <p>Submit</p>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
  
            
          </div>
        </div>
      </div>
    );
  };
  
  export default HomepageCourses;
  